export const ecosackState = (s) => {
	if (s === 1) return 'With customer';
	if (s === 2) return 'Dropped off';
	if (s === 3) return 'Processed';
	return String(s ?? '');
};
